export default __webpack_public_path__ + "static/media/img-ovato-footer-logo-new.879cde9f.png";